/* global analytics */

export type Source =
  | 'adventure_page'
  | 'bucket_list'
  | 'listing_page'
  | 'manage_booking_page'
  | 'search'
  | 'story_page'

type TrackAdventureViewed = {
  adventureId: string
  source: Source
}

type TrackAccommodationViewed = {
  listingId: string
  storyId?: string
  source: Source
}

export const trackAdventureViewed = ({
  adventureId,
  source,
}: TrackAdventureViewed) => {
  analytics.track('Adventure Viewed on Map', {
    adventure_id: adventureId,
    source,
  })
}

export const trackAccommodationViewed = ({
  listingId,
  storyId,
  source,
}: TrackAccommodationViewed) => {
  analytics.track('Accommodation Viewed on Map', {
    listing_id: listingId,
    story_id: storyId,
    source,
  })
}
